/**
 * Email service for sending reports and listing users.
 */

import api from '../lib/api'

export interface UserListItem {
  id: number
  first_name: string
  last_name: string
  full_name: string
  email: string
  phone: string
}

export interface SendReportEmailPayload {
  subject: string
  body_html: string
  recipient_ids: number[]
  attachment_base64?: string
  attachment_filename?: string
}

export async function getUsers(search?: string): Promise<UserListItem[]> {
  const params = search ? { search } : {}
  const response = await api.get<UserListItem[]>('/api/users/list/', { params })
  return response.data
}

export async function sendReportEmail(
  payload: SendReportEmailPayload
): Promise<{ detail: string }> {
  const response = await api.post<{ detail: string }>(
    '/api/send-report-email/',
    payload
  )
  return response.data
}
